/**
 * Porta de entrada depois do login: encaminha conforme o papel.
 *
 * A tela não desenha nada própria — cada papel tem o seu painel, e parar aqui
 * para "escolher" seria um passo a mais sem informação nova. Superadmin vai
 * para a área da plataforma; quem pertence a uma empresa vai para o painel dela.
 *
 * Quem chega sem vínculo com empresa e sem papel de plataforma é o único caso
 * que ganha tela: encaminhá-lo devolveria a conta ao login pelo `RequireRole`,
 * e o laço não explicaria nada a quem ficasse preso nele.
 */

import { Navigate } from "react-router-dom";
import { Logo } from "../ds";

import { useAuth } from "../auth/AuthContext";

/** Papéis que operam dentro de uma empresa. Espelha o `RequireRole` de `/painel`. */
const PAPEIS_DO_TENANT = ["TENANT_ADMIN", "TENANT_EDITOR", "TENANT_VIEWER"];

export default function HomePage() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="shell">
        <p className="muted">Verificando sessão…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/entrar" replace />;
  if (user.must_change_password) return <Navigate to="/trocar-senha" replace />;
  if (user.role === "SUPERADMIN") return <Navigate to="/superadmin" replace />;
  if (PAPEIS_DO_TENANT.includes(user.role)) return <Navigate to="/painel" replace />;

  return (
    <div className="shell">
      <div className="brand">
        <Logo tamanho={32} />
        <b>Aletia</b>
        <span>Armaturen · Valve Passport</span>
      </div>

      <div className="card card-estreito">
        <h1>Conta sem acesso definido</h1>
        <p className="sub">
          Olá, {user.full_name}. Sua conta está ativa, mas não está vinculada a nenhuma empresa
          nem tem perfil de plataforma — por isso não há painel para abrir.
        </p>
        <p className="muted">
          Peça ao administrador que a vincule a uma empresa. Informe o e-mail <b>{user.email}</b> e
          o perfil atual (<code>{user.role}</code>).
        </p>
        <div className="acoes">
          <button type="button" className="btn" onClick={() => void logout()}>
            Sair
          </button>
        </div>
      </div>
    </div>
  );
}
